import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=67ae6c54&scoped=true"
import script from "./topBar.vue?vue&type=script&lang=js"
export * from "./topBar.vue?vue&type=script&lang=js"
import style0 from "./topBar.vue?vue&type=style&index=0&id=67ae6c54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae6c54",
  null
  
)

export default component.exports